import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
  name: 'globalSearchFilter',
  pure: false
})
export class GlobalSearchFilterPipe implements PipeTransform {

  transform(requestList: Array<Request>, filterValue: string): any {
    if (!requestList || !filterValue) {
      return requestList;
    }

    const normalizedFilter = filterValue.toLowerCase().trim();
    return requestList.filter(request => {
      const id = String(request.IDRequest ?? '').toLowerCase();
      const companyName = (request.customer?.CompanyName || '').toLowerCase();
      const email = (request.Email || '').toLowerCase();
      const mobilePhone = (request.customer?.MobilePhone || '').toLowerCase();
      const requestType = (request.request_type?.RequestType || '').toLowerCase();

      return id.indexOf(normalizedFilter) !== -1
        || companyName.indexOf(normalizedFilter) !== -1
        || email.indexOf(normalizedFilter) !== -1
        || mobilePhone.indexOf(normalizedFilter) !== -1
        || requestType.indexOf(normalizedFilter) !== -1;
    });
  }

}
